import {
	FeaturePageProps,
	getLandingPageData,
} from "@/ssr/features"
import { getErrorLog } from "@/utils/errors"
import { SSRNotFound, wrapSSRAuth } from "@/utils/ssr-auth"
import FeaturePage from "../feature/[feature]"
export default FeaturePage

export const getServerSideProps =
	wrapSSRAuth<FeaturePageProps>(async function (context) {
		const feature = String(context.params?.feature)

		try {
			const props = await getLandingPageData(
				feature,
				null,
				"tools",
			)

			return props
		} catch (e) {
			getErrorLog(e, "/tools/[slug]")
			throw new SSRNotFound()
		}
	}, [])
